import SearchComponent from "../../components/Search";
import PaginationComponentOne from "../../components/Pagination/Pagination-O";
import { useCallback, useEffect, useState, useMemo } from "react";
import { Assignment, Moped, Storefront } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getStoreManagerOrders } from "../../redux/StoreManagement/storeManagementActions";

import { debounce } from "lodash";

const OrdersOverviewTable = () => {
  const [activeTab, setActiveTab] = useState("ALL");
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [orderTypeState, setOrderTypeState] = useState("ASSIGNED");
  const [filter, setFilter] = useState("");

  const {
    storeManagerOrders,
    storeManagerOrdersLoading,
    storeManagerOrdersError,
    storeManagerOrdersTotalCount,
  } = useSelector((state) => state.storeManagement);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      getStoreManagerOrders({
        page,
        pageSize,
        filter: filter.toLowerCase(),
        search: searchValue,
      })
    );
  }, [page, pageSize, filter, searchValue, dispatch]);

  console.log(storeManagerOrders);

  const handlePageChange = (paginationData) => {
    // Carbon's Pagination component passes an object with page and pageSize
    if (typeof paginationData === "object") {
      if (paginationData.page !== undefined) {
        setPage(paginationData.page);
      }
      if (
        paginationData.pageSize !== undefined &&
        paginationData.pageSize !== pageSize
      ) {
        setPageSize(paginationData.pageSize);
        setPage(1); // Reset to first page when page size changes
      }
    } else {
      setPage(paginationData);
    }
  };

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    setFilter(tabId);
    dispatch(
      getStoreManagerOrders({
        page,
        pageSize,
        filter: tabId.toLowerCase(),
      })
    );
    setSearchValue("");
  };

  // const handleSearch = useMemo(() =>
  //   // debounce((val) => {
  //   //   setSearchValue(val);
  //   // }, 500),

  //   console.log("Search value")
  // );

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchValue(value);
        setPage(1); // Reset to first page when searching
      }, 500),
    []
  );

  const handleChange = useCallback(
    (e) => {
      const val = e.target.value;
      debouncedSearch(val);
    },
    [debouncedSearch]
  );

  const hanldeViewOrder = (id, product_type) => {
    let productType;
    if (product_type === "crop_input" || product_type === "input_product") {
      productType = "Input";
    } else if (
      product_type === "livestock_input" ||
      product_type === "livestcok"
    ) {
      productType = "Livestock";
    } else if (
      product_type === "mechanization_input" ||
      product_type === "mechanization"
    ) {
      productType = "Mechanization";
    } else if (
      product_type === "advisory_input" ||
      product_type === "advisory"
    ) {
      productType = "Advisory";
    } else if (
      product_type === "insurance_input" ||
      product_type === "insurance"
    ) {
      productType = "Input";
    } else {
      productType = "Input";
    }
    navigate(`/order/${id}/${productType}`);
  };

  const tabs = [
    {
      id: "ALL",
      label: "All",
      bgColor: "bg-[#D8FFDF]",
      textColor: "text-[#2D8C34]",
    },
    {
      id: "PENDING",
      label: "Pending",
      bgColor: "bg-[#FFF7E6]",
      textColor: "text-[#D4A407]",
    },
    {
      id: "DISPATCHED",
      label: "Dispatched",
      bgColor: "bg-[#E6F3FF]",
      textColor: "text-[#0066CC]",
    },
  ];

  const orderTypes = [
    { id: "ASSIGNED", label: "Assigned" },
    {
      id: "INTERNAL",
      label: "Internal",
    },
  ];

  const handleOrderType = (orderType) => {
    setOrderTypeState(orderType);
  };

  return (
    <>
      <div className="p-4 border border-[#E1E6E1] flex justify-between items-center my-3 rounded-lg bg-white">
        <h3 className="text-[#3E473F] text-xl font-semibold">Orders</h3>
        <div className="flex items-center border border-[#E1E6E1] bg-[#F6F7F6] rounded-lg overflow-hidden ">
          {orderTypes.map((orderType) => (
            <button
              key={orderType.id}
              onClick={() => handleOrderType(orderType.id)}
              className={`px-3 py-2 text-center text-xs font-semibold flex items-center justify-center gap-2 ${
                orderTypeState === orderType.id
                  ? "bg-white rounded-lg"
                  : "bg-[#F6F7F6]"
              }`}
            >
              <span
                className={
                  orderTypeState === orderType.id
                    ? "text-[#3E473F]"
                    : "text-[#5C715E]"
                }
              >
                {orderType.label}
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="bg-white rounded-lg border border-[#E1E6E1]">
        <div className="p-4 border-b border-[#E1E6E1]">
          {/* Search */}
          <div className="flex items-center gap-3">
            <div className="flex-1">
              <SearchComponent
                searchValue={searchValue}
                handleChange={handleChange}
                placeholder="Search..."
              />
            </div>
          </div>
        </div>

        {/* Tabs */}
        {tabs.length > 1 && (
          <div className="px-4 pt-4">
            <div className="flex items-center border border-[#E1E6E1] bg-[#F6F7F6] rounded-lg overflow-hidden w-[450px]">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabChange(tab.id)}
                  className={`px-3 py-2 text-center text-sm font-semibold flex items-center justify-center gap-2 w-1/3 ${
                    activeTab === tab.id
                      ? "bg-white rounded-lg"
                      : "bg-[#F6F7F6]"
                  }`}
                >
                  <span
                    className={
                      activeTab === tab.id ? "text-[#3E473F]" : "text-[#5C715E]"
                    }
                  >
                    {tab.label}
                  </span>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Table Content */}
        <div className="overflow-x-auto relative py-4">
          {storeManagerOrdersLoading ? (
            <div className="animate-pulse w-full px-4 mb-4">
              {/* Loading shimmer */}
              <div className="h-12 bg-gray-200 rounded-lg w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg w-full mb-2"></div>
            </div>
          ) : storeManagerOrdersError ? (
            <div className="p-8 text-center">
              <div className="text-red-600 mb-2">Error loading orders</div>
              <div className="text-sm text-gray-500 mb-4">
                {storeManagerOrdersError}
              </div>
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
              >
                Try Again
              </button>
            </div>
          ) : !storeManagerOrders || storeManagerOrders.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-20 px-4">
              <div className="w-[48px] flex justify-center items-center h-[48px] rounded-full border border-[#E1E6E1] bg-[#F6F7F6] mb-4">
                <Assignment className="text-[#5F6D60] w-6 h-6" />
              </div>
              <p className="text-sm font-semibold text-[#5F6D60] text-center">
                {searchValue
                  ? "No orders found for this search term."
                  : "No orders found."}
              </p>
            </div>
          ) : (
            <>
              {/* Table */}
              <table
                className="w-full text-left rounded-lg overflow-hidden border border-[#E1E6E1] mx-4"
                style={{ width: "calc(100% - 2rem)" }}
              >
                <thead className="bg-[#F6F7F6] border-[#E1E6E1]">
                  <tr className="text-sm">
                    <th className="px-4 py-4 font-semibold text-[#5F6D60] rounded-tl-lg rounded-bl-lg">
                      Order ID
                    </th>
                    <th className="px-4 py-4 font-semibold text-[#5F6D60]">
                      Order Date
                    </th>
                    <th className="px-4 py-4 font-semibold text-[#5F6D60]">
                      Order Status
                    </th>
                    <th className="px-4 py-4 font-semibold text-[#5F6D60]">
                      Delivery Type
                    </th>
                    {/* <th className="px-4 py-4 font-semibold text-[#5F6D60]">
                      Urgency
                    </th>
                    <th className="px-4 py-4 font-semibold text-[#5F6D60]">
                      Assigned From
                    </th> */}
                  </tr>
                </thead>
                <tbody className="bg-white border-[#E1E6E1]">
                  {storeManagerOrders.map((order) => (
                    <tr
                      key={order.order_id}
                      onClick={() => {
                        hanldeViewOrder(order?.order_id, order?.product_type);
                      }}
                      className="border-b border-[#E1E6E1] text-sm cursor-pointer hover:bg-[#EDF7EE]"
                    >
                      <td className="px-4 py-4 font-semibold text-[#5F6D60]">
                        {order.order_id}
                      </td>
                      <td className="px-4 py-4 font-semibold text-[#5F6D60]">
                        {order.order_date}
                      </td>
                      <td className="px-4 py-4 items-center flex ">
                        <p
                          className={
                            order.order_status === "PENDING"
                              ? "bg-[#FFF3CE] text-[#D4A407] py-1 px-2 rounded-md text-center font-semibold"
                              : order.order_status === "ASSIGNED"
                              ? "bg-[#E1F7E3] text-[#2B8C34] py-1 px-2 rounded-md text-center font-semibold"
                              : "bg-[#E6F3FF] text-[#0066CC] py-1 px-2 rounded-md text-center font-semibold"
                          }
                        >
                          {order.order_status
                            .toLowerCase()
                            .charAt(0)
                            .toUpperCase() +
                            order.order_status.toLowerCase().slice(1)}
                        </p>
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex items-center justify-center px-2 py-1 bg-[#F6F7F6] rounded-md border border-[#E1E6E1] w-fit gap-0.5 text-sm font-semibold">
                          {order.delivery_type === "pickup" ? (
                            <Storefront
                              fontSize="inherit"
                              className="text-[#5F6D60]"
                            />
                          ) : (
                            <Moped
                              fontSize="inherit"
                              className="text-[#5F6D60]"
                            />
                          )}
                          {order.delivery_type === "door_step"
                            ? "Door Step"
                            : "Pickup"}
                        </div>
                      </td>
                      {/* <td className="px-4 py-4 items-center flex ">
                        <p
                          className={
                            order.urgency === "Urgent"
                              ? "bg-[#FDDED4] text-[#B92020] py-1 px-2 rounded-md text-center font-semibold"
                              : "bg-[#DBFFDF] text-[#2B8C34] py-1 px-2 rounded-md text-center font-semibold"
                          }
                        >
                          {order.urgency}
                        </p>
                      </td>
                      <td className="px-4 py-4 font-semibold text-[#5F6D60]">
                        {order.assignedFrom}
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              <div className="border-t border-[#E1E6E1]">
                <PaginationComponentOne
                  page={page}
                  totalItems={storeManagerOrdersTotalCount}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default OrdersOverviewTable;
